import { red } from '@material-ui/core/colors';

const palette = {
    primary: { main: '#3383FF' }, // blue
    secondary: { main: '#0ABD61' }, // green
    error: { main: red.A400 },
    background: { default: '#F2F2F2' },
    button: { main: '#3383FF', minor: '#a2b6ff' },
    textPrimary: {
        main: '#3383FF', // black
        dark: '#6D7278', // dark gray
        blue: '#3383FF',
        light: '#FFFFFF' //white
    },
    black: { main: '#000000' },
    white: { main: '#FFFFFF' }
};

export default palette;
